export const IS_CLIENT = typeof window !== 'undefined';
